import { useContext, useEffect, useState } from 'react';
import { LabelsWrapper, SectionLabel, SectionsLabelWrapper } from './Lables.styled';
import { useZoneContext } from 'context/ZoneContext';
import { MapTourContext } from 'context/MapTourContext';
import { TourType } from 'pages/Map/components/MapTour';
import { useIsMobile } from 'hooks';
import { Direction } from 'types';

export const Lables = () => {
    const { highestAbsolutePosition, sections, mapState, scale, position } = useZoneContext();
    const { isCurrentTourItem } = useContext(MapTourContext);
    const [showLabels, setShowLabels] = useState(true);
    const isMobile = useIsMobile();

    useEffect(() => {
        setShowLabels(true);
    }, [isMobile]);

    useEffect(() => {
        if (!isMobile) {
            return;
        }
        if (mapState.current.scrollDirection === Direction.LEFT) {
            setShowLabels(false);
        } else if (mapState.current.scrollDirection === Direction.RIGHT) {
            setShowLabels(true);
        }
    }, [mapState.current.scrollDirection]);

    if (!sections.length) {
        return null;
    }

    if (!showLabels) {
        return null;
    }

    return (
        <LabelsWrapper style={{ transform: `translateY(${position.y}px)` }}>
            {sections.map(({ id, min, description }, index, sections) => {
                const isLastSection = index === sections.length - 1;
                const max = isLastSection ? highestAbsolutePosition.y : sections[index + 1].min;
                const isMapTourActiveElement = isCurrentTourItem(TourType.PLAN_UR_LIFE) && index === 0;

                return (
                    <SectionsLabelWrapper key={id} style={{ height: (max - min) * scale }} isMapTourActiveElement={isMapTourActiveElement}>
                        <SectionLabel scale={scale} textVariant="h3">
                            {description}
                        </SectionLabel>
                    </SectionsLabelWrapper>
                );
            })}
        </LabelsWrapper>
    );
};
